module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "33%"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入店铺名称 (20字以内)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.channelName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "channelName", $$v)
      },
      expression: "filters.channelName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "33%"
    },
    attrs: {
      "label": "所属企业："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入所属企业",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.partnerGender),
      callback: function($$v) {
        _vm.$set(_vm.filters, "partnerGender", $$v)
      },
      expression: "filters.partnerGender"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "33%"
    },
    attrs: {
      "label": "联系电话："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入联系电话",
      "maxlength": "11"
    },
    model: {
      value: (_vm.filters.partnerPhone),
      callback: function($$v) {
        _vm.$set(_vm.filters, "partnerPhone", $$v)
      },
      expression: "filters.partnerPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "33%"
    },
    attrs: {
      "label": "地　　区："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入城市",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.partnerRegion),
      callback: function($$v) {
        _vm.$set(_vm.filters, "partnerRegion", $$v)
      },
      expression: "filters.partnerRegion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "33%"
    },
    attrs: {
      "label": "店铺类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.shopType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "shopType", $$v)
      },
      expression: "filters.shopType"
    }
  }, _vm._l((_vm.shopTypeArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("品牌店铺列表")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addPartner()
      }
    }
  }, [_vm._v("添加店铺")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "店铺名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.bbTypeName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.contacts))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属企业",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.enterpriseName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入驻时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.entryTime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "地区",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.region))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "导购",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.guideCount))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.cliSeePartner(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑 ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.totalRowsCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加店铺",
      "visible": _vm.isToExamine,
      "center": true,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('el-form', [_c('el-form', {
    staticClass: "formItem"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "42%"
    },
    attrs: {
      "label": "店铺名称 :",
      "label-width": "88px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入店铺名称 (20字以内)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.shopName),
      callback: function($$v) {
        _vm.shopName = $$v
      },
      expression: "shopName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "42%"
    },
    attrs: {
      "label": "手机号 :",
      "label-width": "88px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号",
      "maxlength": "11",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\d{0})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.shopPhone),
      callback: function($$v) {
        _vm.shopPhone = $$v
      },
      expression: "shopPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "formItem"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "42%"
    },
    attrs: {
      "label": "管理者名字 :",
      "label-width": "88px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入管理者名字",
      "maxlength": "20"
    },
    model: {
      value: (_vm.contactsName),
      callback: function($$v) {
        _vm.contactsName = $$v
      },
      expression: "contactsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "42%"
    },
    attrs: {
      "label": "入驻城市 :",
      "label-width": "88px"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.optionDetails,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.addHandleChangeDetails
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "formItem"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "42%"
    },
    attrs: {
      "label": "详细地址 :",
      "label-width": "88px"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "pickerInput",
      "placeholder": "请输入详细地址",
      "maxlength": "20"
    },
    on: {
      "input": _vm.adcodeclick
    },
    model: {
      value: (_vm.detailedAddress),
      callback: function($$v) {
        _vm.detailedAddress = $$v
      },
      expression: "detailedAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "42%"
    },
    attrs: {
      "label": "门牌号 :",
      "label-width": "88px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入门牌号",
      "maxlength": "20"
    },
    model: {
      value: (_vm.houseNumber),
      callback: function($$v) {
        _vm.houseNumber = $$v
      },
      expression: "houseNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "86%"
    },
    attrs: {
      "label": "店铺视频 :",
      "label-width": "88px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "disabled": true,
      "placeholder": "请上传店铺视频"
    },
    model: {
      value: (_vm.videoUrl),
      callback: function($$v) {
        _vm.videoUrl = $$v
      },
      expression: "videoUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hiddenInput"
  }, [_vm._v(" 选择文件\r\n            "), _c('input', {
    ref: "pathClear",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "video/*"
    },
    on: {
      "change": _vm.handleFile
    }
  })]), _vm._v(" "), (_vm.isEdit) ? _c('span', {
    staticClass: "elUploadTip"
  }, [_vm._v(_vm._s(_vm.isProcessing))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "line-height": "10px"
    }
  }, [_vm._v(" 视频格式仅支持: mp4. 视频大小不能超过 50MB ! "), _c('br'), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoUrl),
      expression: "videoUrl"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.newSeevideo()
      }
    }
  }, [_vm._v("预 览")])], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "86%"
    },
    attrs: {
      "label": "店铺图片 :",
      "label-width": "88px"
    }
  }, [_c('div', {
    staticClass: "upload ",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload3
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticStyle: {
      "width": "172px",
      "height": "82px"
    },
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "line-height": "10px"
    }
  }, [_vm._v("建议尺寸：1200*675，支持的图片格式：jpg、png !")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('button', {
    staticClass: "el-button cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToExamine = false
      }
    }
  }, [_vm._v("关闭")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.videoVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00969e61!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/brandStore.vue
// module id = 1618
// module chunks = 3